export const API_URL = `${import.meta.env.VITE_API_URL}/api`;

export const PRICES = {
  BOOK: 60.00,
  DELIVERY: 20.00,
  get TOTAL() {
    return this.BOOK + this.DELIVERY;
  }
} as const;

export const ENDPOINTS = {
  ORDERS: `${API_URL}/comenzi`,
  PAYMENTS: `${API_URL}/plati`,
  VERIFY_PAYMENT: (orderId: string) => `${API_URL}/plati/stripe/verify/order/${orderId}`,
  GENERATE_AWB: (orderId: string) => `${API_URL}/comenzi/${orderId}/generate-awb`,
  SMS_VERIFICATION: {
    SEND: (orderId: string) => `${API_URL}/sms/orders/${orderId}/verify-phone/send`,
    VERIFY: (orderId: string) => `${API_URL}/sms/orders/${orderId}/verify-phone/verify`,
    STATUS: (orderId: string) => `${API_URL}/sms/orders/${orderId}/verify-phone/status`
  },
  NOMENCLATOR: {
    SEARCH: `${API_URL}/geolocation/search`,
    JUDETE: `${API_URL}/geolocation/county`,
    LOCALITATI: `${API_URL}/geolocation/city`
  },
  SEND_CONFIRMATION: (orderId: string) => `${API_URL}/comenzi/${orderId}/send-confirmation`,
  DOCUMENTS: {
    DOWNLOAD_AWB: (orderId: string) => `${API_URL}/livrare/documents/${orderId}/download/awb`,
    DOWNLOAD_INVOICE: (orderId: string) => `${API_URL}/livrare/documents/${orderId}/download/invoice`
  }
} as const;
